<form class="busca-principal" role="search" (submit)="aoSubmeter($event)">
  <div class="busca-principal-campo">
    <i-lucide class="busca-principal-icone" name="search" size="20"></i-lucide>

    <label class="busca-principal-label" for="busca-principal-input">Buscar serviço</label>
    <input
      id="busca-principal-input"
      class="busca-principal-input"
      type="search"
      autocomplete="off"
      [placeholder]="placeholder"
      [value]="termo()"
      (input)="aoDigitar($event)"
    />

    <button type="submit" class="busca-principal-btn-ia">
      <span class="busca-principal-btn-ia-halo" aria-hidden="true"></span>
      <span class="busca-principal-btn-ia-borda" aria-hidden="true"></span>
      <img
        class="busca-principal-icone-ia"
        ngSrc="assets/images/icones/icon-busca-ia.svg"
        alt=""
        aria-hidden="true"
        width="28"
        height="28"
      />
      <span class="text-btn-ia">Buscar</span>
    </button>
  </div>
</form>
